import { Button, Text } from "@mbank-design/design-system/components";
import { Link } from "react-router-dom";

import "./index.scss";
import { FontColor } from "@mbank-design/design-system/enums";

export const SpecialContactTile = ({title, description, buttonText, buttonLink, idClass, noBtn}: {title: string, description: string, buttonText: string, buttonLink: string, idClass: string, noBtn: boolean}) => {
  const handleRedirect = () => {
    window.location.href = buttonLink || "/formularz-kontaktowy-zamow-auto";
  };
  return (
    <div className={`special-contact-tile ${idClass}`} onClick={handleRedirect}>
      <div className={`special-contact-tile__content ${idClass}`}>
        <div className="special-contact-tile__content__title">
          <Text as="h2" styledAs={"h1"} color={FontColor.LIGHT}>
            {title ? <span dangerouslySetInnerHTML={{ __html: title }} /> : <span>  zamów samochód <br/> dokładnie taki, jak chcesz</span>}
          </Text>
        </div>
        <div className="special-contact-tile__content__description">
          <Text as="p" styledAs={!description ? "body" : "h2"} color={FontColor.LIGHT} dangerouslySetInnerHTML={{ __html: description || "wybierz markę, model i wyposażenie – my zajmiemy się resztą" }}>
          </Text>
        </div>
        <div className="special-contact-tile__content__button" style={{ display: noBtn ? "none" : "block" }}>
          <Link to={buttonLink ?? "/formularz-kontaktowy-zamow-auto"} >
            <Button buttonType="primary">{buttonText ?? "zamów auto"}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
